(ns pfo.widget.editor
  (:require [reagent.core :as reagent :refer [atom]]
            [dommy.core :as dommy :refer-macros [sel1]]))

(def catom clojure.core/atom)

(def editor-line-height 1.5)
(defn xreset! [at contents]
  (reset! at contents))
    
(defn editor [{:keys [text-change-cb
                      disabled]
               :as options} value-atom]
  (let [editor-node (atom nil)
        quill-instance (atom nil)
        in-editor (atom false)
        last-value-atom (catom value-atom)
        value-atom-replace (catom false)]

    (add-watch value-atom "value-atom"
               (fn [_ _ old new]
                 (let [quill @quill-instance]
                   (when (and (not= old new) (not @in-editor))
                     (-> quill (.setContents #js{:ops []}))
                     (-> ^js quill (.-clipboard) (.dangerouslyPasteHTML 0 new))))))

    (reagent/create-class
     {:reagent-render (fn [& _]
                        [:div.editor {:ref #(reset! editor-node %)}])

      :component-did-mount (fn [_]
                             (let [quill (js/Quill. @editor-node (clj->js (merge
                                                                            {:theme "snow"}
                                                                            (when disabled {:readOnly true}))))]
                               (reset! quill-instance quill)
                               (-> quill (.-clipboard) (.dangerouslyPasteHTML 0 @@last-value-atom))
                               (when text-change-cb (text-change-cb @@last-value-atom))
                               (-> quill (.on "text-change" (fn []
                                                              (when-not @value-atom-replace
                                                                (let [value (dommy/html (sel1 @editor-node :div.ql-editor))
                                                                    value-atom @last-value-atom]
                                                                (reset! in-editor true)
                                                                (reset! value-atom (-> quill (.getSemanticHTML)))
                                                                (reset! in-editor false)
                                                                (when text-change-cb (text-change-cb value)))))))
                               (when-let [rows (:rows options)]
                                 (dommy/set-style! @editor-node :height (str (* (inc rows) editor-line-height) "em")))))
      :component-did-update (fn [this _]
                              (let [disabled (boolean (:disabled (reagent/props this)))]
                                (.enable @quill-instance (not disabled)))
                              (let [[_ _ new-value-atom] (reagent/argv this)]
                                (if (not= @last-value-atom new-value-atom)
                                  (do
                                    (reset! value-atom-replace true)
                                    (reset! last-value-atom new-value-atom)
                                    (-> ^js @quill-instance (.deleteText 0 (.getLength @quill-instance)))
                                    (-> ^js @quill-instance (.-clipboard) (.dangerouslyPasteHTML 0 @new-value-atom))
                                    (reset! value-atom-replace false)))))})))
